import {gpCommon, gpStorage, gpSession, gpTemporary} from "../GasPass";

export class Query {
    GASPASS_URL = null;
    LINK_URL = null;

    constructor() {
        //
        if( ( typeof window.location != "undefined" ) && ( typeof window.location.hostname != "undefined" ) ) {
            let hostname = gpCommon.getString( window.location.hostname, null );
            if( hostname !== null ) {
                this.GASPASS_URL = 'https://api-' + hostname + '/api/';
                this.LINK_URL = 'https://api-' + hostname + '/';
            }
        }
    }

    async get( url, params, onComplete, onFail ) {
        let session = gpSession.get();
        if( session != null ) {
            params['session'] = session;
        }

        let temporaryQueryParams = gpCommon.getObject( gpTemporary[url], null );
        if( temporaryQueryParams !== null ) {
            Object.keys( temporaryQueryParams ).map( ( temporaryQueryParamKey ) => {
                let temporaryQueryParamValue = gpCommon.getString( temporaryQueryParams[temporaryQueryParamKey], null );
                if( temporaryQueryParamValue !== null ) {
                    params[temporaryQueryParamKey] = temporaryQueryParamValue;
                }
            });
        }

        // Query
        let fetchController = new AbortController();
        let fetchTimeout = setTimeout(function() {
            fetchController.abort();
            onFail( Error( 'Timeout' ) );
        }, 30000 );

        let timestamp = Math.floor( new Date().getTime() / 1000 );

        let addOn = url + timestamp;
        let fetchData = {
            method: 'POST',
            signal: fetchController.signal,
            cache: 'no-cache',
            credentials: 'omit',
            redirect: 'error',
            body: gpStorage.es( JSON.stringify( params ), addOn )
        };

        fetch( this.GASPASS_URL + url + '?t=' + encodeURIComponent( timestamp ), fetchData ).then( ( response ) => {
            clearTimeout( fetchTimeout );

            if( response.ok ) {
                return response.text();
            }
            else {
                let resoponseStatus = gpCommon.getInteger( response.status, null );
                if( resoponseStatus === 404 ) {
                    onFail( Error( 'Not found' ) );
                }
                else {
                    onFail( Error( 'Error' ) );
                }
            }

        }).then( ( body ) => {
            if( gpCommon.getString( body, null ) !== null ) {
                let dBody = gpStorage.ds( body, addOn );
                if( dBody !== null ) {

                    try {
                        let json = JSON.parse( dBody );
                        if( json !== null ) {
                            let responseStatus = gpCommon.getString( json['status'], null );
                            if( ( responseStatus != null ) && ( responseStatus === 'ok' ) ) {

                                let session = gpCommon.getString( json['session'], null );
                                if( session != null ) {
                                    gpSession.set( session );
                                }

                            }
                            else if( ( responseStatus != null ) && ( responseStatus === 'no_session' ) ) {
                                if( session != null ) {
                                    gpSession.clear();
                                    return true;
                                }
                            }

                            onComplete( json );
                            return true;

                        }
                    }
                    catch( e ) {
                        //
                    }

                    onFail( Error( 'Error' ) );
                }
            }


        }).catch( ( error ) => {
            onFail( Error( 'No response' ) );
        });
    }
}
